// extracted by mini-css-extract-plugin
module.exports = {"dialogRoot":"dialogRoot___2lg88","dialogContainer":"dialogContainer___2Im0A"};